
export default {
    props: {
        tabTitle: {
            type: String
        },
        list: {
            default: {}
        }
    },
    data() {
        return {
            loading: true
        }
    },
    methods: {},
    mounted() {
        if (this.list.goodsNo) {
            this.loading = false
        }
    }
}
